/** @jsx _j **/

/** @jsxFrag _f **/
var _require = require('astroturf'),
    _j = _require.jsx,
    _f = _require.F;

import { MDXRenderer } from 'gatsby-plugin-mdx';
export default function TsDocComment(_ref) {
  var comment = _ref.comment;

  if (!(comment === null || comment === void 0 ? void 0 : comment.mdx)) {
    return null;
  }

  return _j("div", {
    css: [require("./TsDocComment-CssProp1_div.module.css"), []]
  }, _j(MDXRenderer, null, comment.mdx.body));
}